import React, { useState, useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function Binary() {
  const [text, setText] = useState("");
  const [code, setCode] = useState("");

  const textToCode = (input) => {
    if (!input) return "";
    return input
      .split("")
      .map((char) => char.charCodeAt(0).toString(2).padStart(8, "0"))
      .join(" ");
  };

  const codeToText = (input) => {
    if (!input) return "";
    return input
      .trim()
      .split(" ")
      .map((bin) => String.fromCharCode(parseInt(bin, 2)))
      .join("");
  };

  const handleTextChange = (e) => {
    let value = e.target.value;
    setText(value);
    textToCode(value);
  };

  const handleCodeChange = (e) => {
    let value = e.target.value.replace(/[^01 ]/g, '');
    value = formatInput(value);
    setCode(value);
    codeToText(value);
  };

  const formatInput = (input) => {
    input = input.replace(/\s+/g, "");
    const formatted = input.match(/.{1,8}/g) || [];
    return formatted.join(" ");
  };

  useEffect(() => {
    if (document.activeElement.name === "text") {
      setCode(textToCode(text));
    } else if (document.activeElement.name === "code") {
      setText(codeToText(code));
    }
  }, [text, code]);

  return (
  <>
    <HelmetProvider>
      <Helmet>
        <title>Binario | ERI</title>
      </Helmet>
    </HelmetProvider>
    <div id="ciphers" className="content">
      <div id="binary" className="content-wrapper">
        <div className="content-title">
          <h1 className="title">Binario</h1>
          <p className="subtitle">El sistema binario es un sistema de numeración en el que los caracteres se representan utilizando únicamente cero y uno.</p>
        </div>
        <div className="content-main">
          <div className="content-code">
            <div className="content-encrypt">
              <label className="text-left" htmlFor="code">Binario</label>
              <textarea id="input-code" className="input-left" name="code" value={code} spellCheck="false"
                onChange={handleCodeChange}
              />
              <span className="info info-left">Carácteres permitidos: 0, 1 y espacio</span>
              <div className="buttons">
                <button className="btn btn-primary" onClick={() => setCode(textToCode(text))}><span>Cifrar </span><i className="fas fa-arrow-right"></i></button>
                <button className="btn btn-primary" onClick={() => setText(codeToText(code))}><i className="fas fa-arrow-left"></i><span> Descrifrar</span></button>
              </div>
              <label className="text-right" htmlFor="text">Texto</label>
              <textarea id="input-text" className="input-right" name="text" value={text} spellCheck="false"
                onChange={handleTextChange}
              />
              <span className="info info-right">Carácteres permitidos: Números, letras y espacio</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
  );
}
